import { apiSlice } from "features/api/apiSlice";

const getSpecialties = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getSpecialties: build.query({
      query: () => "/doctors/mwell/specializations",
      transformResponse: (res) => res.d.data,
    }),
  }),
});

export const { useGetSpecialtiesQuery } = getSpecialties;
